import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $noMargin?: boolean;
}

function noMarginStyle({ $noMargin }: Props) {
  if ($noMargin) {
    return css`
      margin-top: 0;
      margin-bottom: -0.4rem;
    `;
  }
}

export default styled.small<Props>`
  display: block;
  font-size: 0.933333rem;
  line-height: 1.85;
  color: ${Colours.grey};
  white-space: normal;
  max-width: 10rem;
  margin-top: 0.75rem;
  font-weight: normal;
  ${noMarginStyle}
`;
